import lodashPickBy from 'lodash/pickBy';
import type { Dictionary } from 'lodash';

export const pickBy = <T extends Record<string, unknown>>(
  object: T,
  predicate?: (value: unknown, key: string) => boolean,
): Dictionary<unknown> => lodashPickBy(object, predicate);
